import React from 'react'
import { useTranslation } from 'react-i18next'
import { BuildingFragment } from '../../../generated/graphql'
import {
  energyPerAreaUnit,
  energyPerYearUnit,
  powerPerAreaUnit,
  powerUnit,
} from '../../../util/formatters'
import { Provider } from '../../../calculators/providers/common/Provider'
import { getFilteredResultsFromProviders } from '../../../calculators/calculator-result-utility'
import { purchasedEnergySubCategories } from '../../../provider/result-categories'
import { mapNamedResultsToRows } from './report-utility'
import { ReportTable } from './ReportTable'

type Props = {
  providers: Provider[]
  building?: BuildingFragment
}

export function ReportPurchasedEnergyTable({
  providers,
  building,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  const area = building?.area

  const subCategoriesWithResults = purchasedEnergySubCategories.map(
    (subCategory) => ({
      name: t(subCategory.nameKey),
      result: getFilteredResultsFromProviders(providers, subCategory),
    }),
  )

  const rows = mapNamedResultsToRows(subCategoriesWithResults, {
    area,
    totalRowName: t('common.total'),
  })

  const energyHeaderCells = [
    { firstRow: t('unitName.totalEnergy'), secondRow: energyPerYearUnit },
  ]
  const powerHeaderCells = [
    { firstRow: t('unitName.maxPower'), secondRow: powerUnit },
  ]

  if (area) {
    energyHeaderCells.push({
      firstRow: t('unitName.totalEnergyPerArea'),
      secondRow: energyPerAreaUnit,
    })
    powerHeaderCells.push({
      firstRow: t('unitName.maxPowerPerArea'),
      secondRow: powerPerAreaUnit,
    })
  }

  const headerCells = [...energyHeaderCells, ...powerHeaderCells]

  return <ReportTable headerCells={headerCells} rows={rows} />
}
